import { render, staticRenderFns } from "./OrderSlider.vue?vue&type=template&id=2f16d274&"
import script from "./OrderSlider.vue?vue&type=script&lang=js&"
export * from "./OrderSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports